import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import Button from '../../components/Button';

import shapeImg1 from '../../assets/img/hero/shape-1-1.png';
import shapeImg2 from '../../assets/img/hero/shape-2-1.png';
import heroImg1 from '../../assets/img/hero/hero-2-1.png';
import heroImg2 from '../../assets/img/hero/hero-2-2.jpg';
import heroImg3 from '../../assets/img/hero/hero-2-3.jpg';
import heroIcon from '../../assets/img/hero/icon-1.png';

const Hero = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="it-hero-2-area p-relative  z-index grey-bg-2">
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="PO_fBTkoznc"
        onClose={() => openModal()}
      />
      <div className="it-hero-shape-1">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6">
            <div className="it-hero-2-content">
              <h1
                className="it-hero-2-title pb-5 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                رعاية متخصصة للأسنان لابتسامتك المشرقة
              </h1>
              <div
                className="it-hero-text mb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".5s"
              >
                <p>
                  من المهم الاعتناء بالمريض، حيث سيتبعه المريض، لكنه في الوقت
                  نفسه سيعاني من بعض الألم والمعاناة الشديدين. للوصول إلى أصغر
                  التفاصيل.
                </p>
              </div>
              <div
                className="it-hero-button-wrapper wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".7s"
              >
                <div className="it-hero-button flex-wrap d-sm-flex align-content-center">
                  <Link className="it-btn-theme mr-30" to="/about-us">
                    <Button btnText="اكتشف المزيد" />
                  </Link>
                  <div className="it-hero-video">
                    <Link
                      className="play-icon pulse-anim popup-video"
                      to="#"
                      onClick={() => openModal()}
                    >
                      <i className="fa-sharp fa-solid fa-play"></i>
                    </Link>
                    <Link
                      className="popup-video"
                      to="#"
                      onClick={() => openModal()}
                    >
                      شاهد الآن
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="it-hero-2-right p-relative align-items-end d-flex justify-content-between">
              <div className="it-hero-2-wrap">
                <div className="it-hero-2-thumb-1 p-relative">
                  <img src={heroImg1} alt="" />
                  <div className="it-hero-2-shape-1">
                    <img src={shapeImg2} alt="" />
                  </div>
                </div>
                <div className="it-hero-2-thumb-2">
                  <img src={heroImg2} alt="" />
                </div>
              </div>
              <div className="it-hero-2-thumb-3">
                <img src={heroImg3} alt="" />
              </div>
              <div className="it-hero-doctor-wrap">
                <div className="it-hero-doctor-box d-flex align-items-start justify-content-start">
                  <div className="it-hero-doctor-icon">
                    <img src={heroIcon} alt="" />
                  </div>
                  <div className="it-hero-doctor-text text-end">
                    <span>200+</span>
                    <p>
                      أفضل الأطباء في العالم <br />
                      التشاور
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
